import HeadlineCell from './HeadlineCell';

export default HeadlineCell;
